var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var diagramConfiguration = require('../diagramConfiguration');
var Point = require('../../../../../../../models/data/point');
var pointWrite = require('../../../../data/components/writeModal');
var multiPointWriteModal = require('../../../../data/components/multiPointWriteModal');
var pointTrendModal = require('../../../../data/components/pointTrendModal');
var modalForm = require('../../../../layout/components/modalForm');
var pointOverride = modalForm(require('../../../../data/models/override'));
var isAggregatePoint = require('../../../../data/isAggregatePoint');
var canWriteColumn = require('../../../../data/canWriteColumn');

const $ = go.GraphObject.make;  // for more concise visual tree definitions

function openPointAction(clickedColumn) {
  if (edit.vm.editing()) return;

  if (!canWriteColumn(clickedColumn) || isAggregatePoint(clickedColumn)) {
    return pointTrendModal.open(clickedColumn);
  }
  if (Number(clickedColumn.in.overrides)) {
    return pointOverride.editDialogue(clickedColumn, clickedColumn.parentEquipmentRid);
  }
  if (clickedColumn.in.writeGroup) {
    return multiPointWriteModal.editDialogue(clickedColumn, clickedColumn.parentEquipmentRid);
  }
  if (Number(clickedColumn.in.writable)) {
    return pointWrite.editDialogue(clickedColumn, clickedColumn.parentEquipmentRid);
  }

  return pointTrendModal.open(clickedColumn);
}

function datasetTemplate(map, useGeoPositioning, submitCallback, diagram) {
  return $(go.Node, "Auto",
    { 
      deletable: false,
      locationSpot: go.Spot.TopLeft,
    },
    new go.Binding("cursor", "", data => {
      return edit.vm.editing() ? "pointer" : "default";
    }),
    new go.Binding("selectable", "", data => {
      return edit.vm.editing();
    }),
    new go.Binding("movable", "", data => {
      return edit.vm.editing();
    }),
    useGeoPositioning ? 
      new go.Binding("location", "latlong", data => {
        const pos = map.project(data, map.getZoom());
        return new go.Point(pos.x, pos.y);
      }).makeTwoWay((pt, data) => {
        if (updatingGoJs) {
          return data.latlong; // no-op
        } else {
          const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
          return [ll.lat, ll.lng];
        }
      })
    : 
      new go.Binding("location", "latlong", data => {
        return new go.Point(data[0], data[1]);
      }),
    $(go.Panel, "Table", {
      row: 1, 
      margin: new go.Margin(diagramConfiguration.calculateCellHeight() + 2, 0, 0, 0),
      stretch: go.GraphObject.Horizontal,
    },
      $(go.TextBlock, { 
        alignment: go.Spot.TopLeft,
        font: `500 ${diagramConfiguration.fontSize - 2}pt 'Roboto Flex', monospace`,
        margin: new go.Margin(0, 0, 4, 0),
        wrap: go.TextBlock.None,
        stroke: "white",
        columnSpan: 3,
      }, new go.Binding("text", "name")),
      $(go.Shape, "LineH", {
        stretch: go.GraphObject.Horizontal,
        stroke: "white",
        strokeWidth: 1,
        height: 1,
        columnSpan: 3,
        alignment: go.Spot.Bottom,
        margin: new go.Margin(diagramConfiguration.calculateCellHeight(), 0, 4, 0),          
      }),
      $(go.Panel, "Table", {
          row: 2, 
          stretch: go.GraphObject.Horizontal,
        },
        $(go.Panel, "Vertical",
          new go.Binding("itemArray", "columns"),
          {
            stretch: go.GraphObject.Horizontal,
            itemTemplate: $(go.Panel, "Horizontal",
              {
                stretch: go.GraphObject.Horizontal,
              },
              $(go.TextBlock,
                {
                  stroke: "white",
                  font: `${diagramConfiguration.fontSize - 3}pt 'Roboto Flex', monospace`,
                  margin: new go.Margin(3, 5, 3, 0),
                },
                new go.Binding("text", "name")
              ),

              // Conditional Rendering: Boolean points (Square) OR Normal Number
              $(go.Panel, "Auto", {
                  click: function(e, obj) {
                    return openPointAction(obj.panel.data);
                  }
                },
                new go.Binding("visible", "", function(column) {
                  // Only show the square for boolean points and valid time
                  const columnData = column && column.in;
                  if (!columnData) return false;
                  if (columnData.unit !== "bool") return false; // Only show square for boolean points
                  var displayValue = Point.readValue(Date.now() - column.in.time < 3600000 ? column.in : undefined) || 'null';
                  return displayValue !== '---'; // Show square if value is valid
                }),
                $(go.Shape, "Square", 
                  {
                    width: 12, 
                    height: 12,
                    strokeWidth: 1,
                    stroke: "#58abe2"
                  },
                  new go.Binding("name", "", function(column) {
                    return `Square_${column.datasetRid}_${column.id}`;
                  }),
                  new go.Binding("id", "", function(column) {
                    return `Square_${column.datasetRid}_${column.id}`;
                  }),
                  new go.Binding("fill", "", function(column) {
                    if (column?.in?.unit !== "bool") return "transparent";
                    column.in.equipmentClass = "Boolean"
                    let columnObj = {
                      column
                    };
                    var displayValue;
                    var color = "#58abe2"; // Default color
                    if (column['@rid'] && column.in && column.in['@rid']) {
                      if (
                        !diagram.model.modelData[`${column['@rid'].toString()}_${column.in['@rid'].toString()}`] && 
                        diagram.model.modelData[`${column['@rid'].toString()}_${column.in['@rid'].toString()}`] != 0
                      ) {
                        diagram.model.commit(function(mod) {
                          mod.set(mod.modelData, `${column['@rid'].toString()}_${column.in['@rid'].toString()}`, String(column.in.value));
                        });
                        const pointSubscriberObj = diagram && (diagram.pointSubscriber || diagram.pointSubscriberObj);
                        if (pointSubscriberObj) {
                          pointSubscriberObj.subscribe(columnObj, diagram);
                        }
                        
                      }
                      displayValue = Point.readValue(Date.now() - column.in.time < 3600000 ? column.in : undefined) || 'null';
                      var reverseBoolean = Boolean(Number(columnObj.column.in.alarmReverseBoolean));
                      if (displayValue && displayValue != '---' && displayValue != 'null') {
                        if ((columnObj.column.in.alarmEnabled == 1) && !reverseBoolean) {
                          color = "#ff395a"; // Red for alarm tripped
                        } else {
                          color = "#58abe2"; // Blue for normal state
                        }
                      }
                    }
                    return displayValue && displayValue != '---' && displayValue != 'null' ? color : "transparent";
                  }),
                  new go.Binding("stroke", "", function(column) {
                    if (column?.in?.unit !== "bool") return "transparent";

                    const current = Number(Boolean(Number(column?.in?.value)));
                    let color;
                    const reverseBoolean = Boolean(Number(column.in.alarmReverseBoolean));
                    if (Boolean(Number(column.in.overrideActive))) {
                      color = "#cccc52";
                    } else if (column.in.alarmEnabled == 1 && reverseBoolean && !current) {
                      color = "#ff395a";
                    } else {
                      color = "#58abe2";
                    }
                    return color;
                  }),
                )
              ),
              // Display the number if it's NOT a boolean
              $(go.TextBlock,
                {
                  stroke: "white",
                  font: `bold ${diagramConfiguration.fontSize - 3}pt 'Roboto Flex', monospace`,
                  margin: new go.Margin(3.5, 5, 0, 0),
                  click: function(e, obj) {
                    return openPointAction(obj.panel.data);
                  }
                },
                new go.Binding("cursor", "", data => {
                  return edit.vm.editing() ? "default" : "pointer";
                }),
                new go.Binding("visible", "", function(column) {
                  // Only show the number if it's not a boolean point or if the boolean point does not have a valid time
                  const columnData = column && column.in;
                  if (!columnData) return false;
                  if (columnData.unit === "bool") {
                    var displayValue = Point.readValue(Date.now() - column.in.time < 3600000 ? column.in : undefined) || 'null';
                    if (displayValue === '---') return true; // Hide if boolean point has no valid time
                    else return false; // Show if boolean point has valid time
                  } 
                  return true; // Show for all non-boolean points
                }),
                new go.Binding("text", "", function(column) {
                  if (!column || !column.in) return "";
                  if (column?.in?.unit == "bool") return "---"; 
                  let columnObj = {
                    column
                  };
                  
                  var displayValue = Point.readValue(Date.now() - column.in.time < 3600000 ? column.in : undefined) || 'null';
                  var unit = Point.formatUnit(columnObj.column.in);
                  if (column['@rid'] && column.in && column.in['@rid']) {
                    if (
                      !diagram.model.modelData[`${column['@rid'].toString()}_${column.in['@rid'].toString()}`] && 
                      diagram.model.modelData[`${column['@rid'].toString()}_${column.in['@rid'].toString()}`] != 0
                    ) {
                      diagram.model.commit(function(mod) {
                        mod.set(mod.modelData, `${column['@rid'].toString()}_${column.in['@rid'].toString()}`, String(column.in.value));
                      })
                      
                      const pointSubscriberObj = diagram && (diagram.pointSubscriber || diagram.pointSubscriberObj);
                      if (pointSubscriberObj) {
                        pointSubscriberObj.subscribe(columnObj, diagram);
                      }
                    }
                  }
                  
                  return `${displayValue} ${unit}`;
                }),
                new go.Binding("stroke", "", function(column) {
                  const columnData = column && column.in;
                  if (!columnData) return "#58abe2"; // Fall back to default color when data is missing

                  if (Number(columnData.overrideActive)) return "#cccc52";
                  if (columnData.alarmStatus === "Alarm Tripped") return "#ff395a";
                  return "#58abe2"; // Default color
                }),
                new go.Binding("isStrikethrough", "", function (column) {
                  if (column && column.in && column.in.time) {
                    return Date.now() - column.in.time > 60000 ; // Strike through if data is outdated
                  } else {
                    return false;
                  }
                }),
                new go.Binding("isUnderline", "", function (column) {
                  return canWriteColumn(column) &&
                    !isAggregatePoint(column) &&
                    column &&
                    column.in &&
                    Boolean(Number(column.in.writable) || Number(column.in.overrides));
                })
              )
            )
          }
        )
      )
    )
  );
}

datasetTemplate._test = {
  openPointAction: openPointAction
};

module.exports = datasetTemplate;
